import { UserIdentityFormProps } from './props';
import UserIdentityFormRenderer from './Renderer';

/**
 * UserIdentityForm Component
 * A wrapper component that renders the KYC (Know Your Customer) identity verification form.
 * Passes through props to the UserIdentityFormRenderer component.
 *
 * @component
 * @param {Object} props - Component props
 * @param {boolean} [props.usePartialForm] - Whether to render only the form content without layout
 * @param {boolean} [props.isContainerColor] - Whether to use container background color styling
 * @param {Object} [props.kycSuccessProps] - Props for the success view component
 * @param {bigint|null} [props.externalOriginId] - External origin ID to override default origin
 * @returns {JSX.Element} The rendered KYC form with appropriate configuration
 *
 * @example
 * // Basic usage with partial form
 * <UserIdentityForm
 *   usePartialForm={true}
 *   isContainerColor={false}
 *   kycSuccessProps={{
 *     showSuccess: false,
 *     title: "",
 *     description: "",
 *     buttonLabel: "",
 *     onClick: () => {},
 *     isLoading: false
 *   }}
 *   externalOriginId={123n}
 * />
 */
export default function UserIdentityForm({
  usePartialForm,
  isContainerColor,
  kycSuccessProps,
  externalOriginId,
}: UserIdentityFormProps) {
  return (
    <UserIdentityFormRenderer
      usePartialForm={usePartialForm}
      isContainerColor={isContainerColor}
      kycSuccessProps={kycSuccessProps}
      externalOriginId={externalOriginId}
    />
  );
}
